import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { isNil } from 'lodash';

import { AbstractFilterTypeComponent } from '../../models/abstract-filter-type.component';
import { Mention } from '../../../Mentions/models/mention';
import { engagementFilterKeys, EngagementFilterModel, EngagementFilterValueModel } from '../../models/engagement-filter.model';

@Component({
    selector: 'agpr-engagement-filter',
    templateUrl: './engagement-filter.component.html',
    styleUrls: ['./engagement-filter.component.scss'],
    providers: [
        {
            provide: AbstractFilterTypeComponent,
            useExisting: EngagementFilterComponent
        }
    ],
    standalone: false
})
export class EngagementFilterComponent extends AbstractFilterTypeComponent implements OnInit, OnChanges {
    readonly engagementFilterKeys = engagementFilterKeys;
    readonly engagementMaximum: number = Mention.maxEngagementTotal;
    readonly engagementMinimum: number = 0;
    readonly tooltips = {
        'amplification': 'Social.filter.engagements.amplification.tooltip',
        'conversation': 'Social.filter.engagements.conversation.tooltip',
        'applause': 'Social.filter.engagements.applause.tooltip'
    };

    @Input() declare filter: EngagementFilterModel;

    value: EngagementFilterValueModel;

    ngOnInit() {
        this.refresh();
    }

    ngOnChanges() {
        this.refresh();
    }

    refresh() {
        this.value = this.filter.getCurrentValue();
    }

    update() {
        Object.values(this.value).forEach(value => {
            if (isNil(value.min)) {
                value.min = NaN;
            }
            if (isNil(value.max)) {
                value.max = NaN;
            }
        });
        this.filter.setCurrentValue(this.value);
    }
}
